import { Container, Typography, Grid } from '@mui/material';
import { HelpGuideCard } from 'src/components/ContentPageCards/HelpGuidesCard';
import {
  PictureAsPdf,
  FileDownloadOutlined,
  OndemandVideoOutlined,
  LaunchOutlined
} from '@mui/icons-material';

import { ContentPageTitle } from 'src/components/ContentPageTitle/ContentPageTitle';

const HelpPage = () => {
  return (
    <>
      <ContentPageTitle currentPageTitle="Help guides and videos" />
      <Container maxWidth="lg">
        <Typography variant="body2" sx={{ mt: 3 }}>
          Visit the Help section to access step-by-step guides, short videos, FAQs and links to
          additional resources and policies.
        </Typography>
        <Typography color="primary.main" variant="h2" sx={{ mt: 3 }}>
          Download a 'How to guide'
        </Typography>
        <Grid container spacing={2}>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Self-record an activity using Quick log"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Edit or delete a Quick log entry"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Start, edit or submit your professional development plan (PDP)"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Log CPR"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Log Advanced Life Support (ALS)"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Use the Measuring outcomes tool to record a practice improvement"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Use the Reviewing performance tool to record a post-activity reflection"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Use Browse to find a CPD approved activity"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Use the Group or practice activity form to record CPD with colleagues"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Record Specific Requirement activities with additional skill/qualification"
              Description=""
              CardIcon={PictureAsPdf}
              ButtonIcon={FileDownloadOutlined}
              Button={{ Text: 'Download', URL: '', Target: '_blank' }}
            />
          </Grid>
        </Grid>

        <Typography color="primary.main" variant="h2" sx={{ mt: 3 }}>
          View our short 'how to' videos
        </Typography>
        <Grid container spacing={2}>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Log CPR"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Log CPR – record your GP Specialist high-level requirement"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Quick tips for using Quick log – record an activity"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Post-activity reflection – using the Reviewing performance tool"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Post-activity quality improvement – using the Measuring outcomes tool"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
          <Grid item md={4} sx={{ display: 'flex', width: '100%' }}>
            <HelpGuideCard
              Heading="Record an activity with colleagues – using the Group or practice activity"
              Description=""
              CardIcon={OndemandVideoOutlined}
              ButtonIcon={LaunchOutlined}
              Button={{ Text: 'View', URL: '', Target: '_blank' }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
export { HelpPage };
